import React, { useRef } from 'react'
import { HtmlTag } from '../libs/helpers'
import { BlocksRenderer } from '@strapi/blocks-react-renderer'
import { RxCaretDown, RxCaretUp } from 'react-icons/rx'

import * as styles from './tabs.module.scss'

const BasicTabView = ({ theme, tabItem, activeTab, handleClick, isAccordion, title, description }) => {
  const tabTitleRef = useRef(null)
  const smoothScrollTo = (sectionId) => {
    const section = document.getElementById(sectionId)
    if (section && tabTitleRef.current) {
      tabTitleRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return (
    <>
      {theme === 'basic' && (
        <section className={styles['basicTabSection']}>
          <div id='tab-container' className={styles['container']}>
            {title && <HtmlTag tagName={title.header}>{title.copy}</HtmlTag>}
            <BlocksRenderer content={description} />
            <div ref={tabTitleRef} className={isAccordion ? styles.accordionContainer : styles.tabContainer}>
              {isAccordion ? (
                tabItem.map((item, index) => (
                  <React.Fragment key={index}>
                    <button
                      id={`accordion-${index + 1}`}
                      className={`${styles.accordionTitle} ${styles.tablink} accordion-item-${index + 1}`}
                      data-expanded={index === activeTab ? 'true' : 'false'}
                      aria-controls={`sect-${index + 1}`}
                      onClick={() => {
                        handleClick(index)
                        smoothScrollTo(`sect-${index + 1}`)
                      }}
                    >
                      {item.title}
                      {index === activeTab ? <RxCaretUp /> : <RxCaretDown />}
                    </button>
                    <div
                      id={`sect-${index + 1}`}
                      className={`${styles.accordionContent} ${styles.tabContentWrap} container-${item.title
                        .toLowerCase()
                        .replace(/[^A-Za-z0-9-]+/g, '-')}`}
                      role="region"
                      aria-labelledby={`accordion-${index + 1}`}
                      aria-hidden={index !== activeTab}
                    >
                      <div className={`${styles.insideContent} ${styles.left}`}>
                        <p>{item.sidebar}</p>
                      </div>
                      <div className={`${styles.insideContent} ${styles.right}`}>
                        <BlocksRenderer content={item.description} />
                      </div>
                    </div>
                  </React.Fragment>
                ))
              ) : (
                <>
                  <div className={styles['tabList']} role="tablist" aria-controls="tab-container">
                    {tabItem.map((item, index) => (
                      <button
                        key={index}
                        className={`${styles.accordionTitle} ${styles.tablink} accordion-item-${index + 1}`}
                        role="tab"
                        data-expanded={index === activeTab ? 'true' : 'false'}
                        aria-controls={`sect-${index + 1}`}
                        onClick={() => handleClick(index)}
                      >
                        {item.title}
                      </button>
                    ))}
                  </div>
                  {tabItem.map((item, index) => (
                    <div
                      key={index}
                      id={`tabpanel-${index + 1}`}
                      className={`${styles.accordionContent} ${styles.tabContentWrap}`}
                      role="tabpanel"
                      aria-labelledby={`sect-${index + 1}`}
                      data-expanded={index === activeTab ? 'true' : 'false'}
                    >
                      <div className={`${styles.insideContent} ${styles.left}`}>
                        <p>{item.sidebar}</p>
                      </div>
                      <div className={`${styles.insideContent} ${styles.right}`}>
                        <BlocksRenderer content={item.description} />
                      </div>
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
        </section>
      )}
    </>
  )
}

export default BasicTabView
